<template>
  <div class="personal-wallpaper-detail">
    <div class="hd">
      <img class="author-avatar" :src="info.avatar" @click="handleBackAuthor">
      <div class="author-name">
        {{ info.nickname }}
      </div>
      <i v-if="info.user_type === 1" class="icon-uup" />
    </div>
    <h1 class="wallpaper-title">
      {{ dynamicdetail.wname }}
    </h1>
    <div class="bd">
      <strong v-if="dynamicdetail.status === 0" class="wallpaper-disable">该壁纸已下架</strong>
      <template v-else>
        <span v-if="!hideTips" class="time-tip">只能预览动态壁纸前10秒哦~</span>
        <div class="previewer">
          <video
            class="video"
            :src="dynamicdetail.preview_video"
            :poster="dynamicdetail.preview_jpg"
            muted
            x5-video-player-type="h5"
            playsinline
            controls
            autoplay
            @click="handlePlay"
            @play="handlePlay"
          />
          <span />
        </div>
      </template>
    </div>
    <div class="bt">
      <div class="download-box" @click="handleShowDownloadTips">
        使用该壁纸
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import wx from 'weixin-js-sdk'

export default {
  name: 'PersonalMobileWallpaperDetail',
  props: {
    info: {
      type: Object,
      default() {
        return {}
      },
    },
    dynamicdetail: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      hideTips: false,
      downloadTipsVisible: true,
      // 是否已经更新过分享信息
      hadSetAppShareMessage: false,
    }
  },
  computed: {
    ...mapState({
      isLoadWxSdk: state => state.isLoadWxSdk,
    }),
  },
  watch: {
    isLoadWxSdk: {
      handler(status) {
        if (status && !this.hadSetAppShareMessage) {
          this.hadSetAppShareMessage = true
          this.onMenuShareAppMessage()
        }
      },
      immediate: true,
    },
  },
  methods: {
    transformProtocol(value) {
      if (typeof value === 'string') {
        return value.replace(/https?:/, '')
      }

      return value
    },
    handlePlay() {
      this.hideTips = true
    },
    handleBackAuthor() {
      this.$router.push({
        path: '/personal/author',
        query: { author_uid: this.info.uid },
      })
    },
    handleShowDownloadTips() {
      this.downloadTipsVisible = true
      this.$emit('close', true)
    },
    handleHideDownloadTips(value) {
      this.downloadTipsVisible = false
    },
    onMenuShareAppMessage() {
      wx.checkJsApi({

        jsApiList: [
          'checkJsApi',
          'onMenuShareTimeline', // 分享到微信朋友圈
          'onMenuShareAppMessage', // 分享给微信朋友
          'onMenuShareQQ', // 分享到QQ
          'onMenuShareQZone', // 分享到QQ空间
          'updateAppMessageShareData', // 分享到微信及QQ（新接口）
          'updateTimelineShareData'],
        success: (res) => {
          wx.updateAppMessageShareData({
            title: '元气桌面', // 分享标题
            desc: '终于找到我最喜欢的壁纸了，推荐你一起使用', // 分享描述
            // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            // link: 'https://wp.cheetahfun.com/personal/wallpaper?dwid=72055',
            link: location.href.replace(/#.*$/, ''),
            imgUrl: this.dynamicdetail.preview_jpg, // 分享图标
            success() {
              // 设置成功
              console.log('updateAppMessageShareData api success 成功')
            },
            fail(err) {
              console.warn('updateAppMessageShareData  api err 失败', err)
              wx.closeWindow()
            },
          })
          wx.updateTimelineShareData({
            title: '元气桌面', // 分享标题
            desc: '终于找到我最喜欢的壁纸了，推荐你一起使用', // 分享描述
            link: location.href.replace(/#.*$/, ''), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.dynamicdetail.preview_jpg, // 分享图标
            success() {
              // 设置成功
              console.log('updateTimelineShareData api success 成功')
            },
            fail(err) {
              console.warn('updateTimelineShareData api err 失败', err)
              wx.closeWindow()
            },
          })
        },
        fail: (err) => {
          console.log('check api fail:', err)
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@media (max-width: 900px) {
  .pc-only {
    display: none !important;
  }
}
@media (min-width: 901px) {
  .mobile-only {
    display: none !important;
  }
}
.personal-wallpaper-detail {
  position: relative;
  box-sizing: border-box;
  font-size: 14px;
  color: #727c8e;
  .hd {
    margin-top: .4rem;
    margin-left: .15rem;
    position: relative;
    display: flex;
    align-items: center;
  }
  .wallpaper-title {
    display: inline-block;
    vertical-align: middle;
    font-size: .17rem;
    color: #333;
    margin-top: 0.17rem;
    margin-left: .15rem;
  }
  .author-avatar {
    border-radius: 50%;
    width: .4rem;
    height: .4rem;
    margin-right: .12rem;
  }
  .author-name {
      font-size: .14rem;
  }
  .bd {
    position: relative;
    margin: 23px 0 0 .15rem;
    background: #000;
    overflow: hidden;
    video {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 999;
    }
    .previewer {
        position: relative;
        width: 3.53rem;
        padding-top: 2.00rem;
    }
    .video {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 9;
    }

    .wallpaper-disable {
      position: absolute;
      top: 250px;
      left: 0;
      right: 0;
      font-size: 20px;
      text-align: center;
      letter-spacing: 10px;
      color: #fff;
    }
  }
  .bt {
    display: flex;
    justify-content: center;
    width: calc(3.75rem - .07rem);
    box-sizing: border-box;
    margin-top: .17rem;
  }
  .icon-uup {
    display: inline-block;
    vertical-align: middle;
    width: 86px;
    height: 26px;
    background: url('~@/assets/images/uup.png') 0 0 no-repeat;
  }
  .icon-download {
    display: inline-block;
    vertical-align: middle;
    width: 13px;
    height: 12px;
    background: url('~@/assets/images/icon-download.png') 0 0 no-repeat;
  }
  .tips {
    position: absolute;
    right: 186px;
    bottom: 16px;
    font-size: 12px;
    color: #b1b5c2;
  }
  .time-tip {
    position: absolute;
    z-index: 9999;
    left: 0;
    right: 0;
    top: 0;
    height: 110px;
    line-height: 40px;
    text-align: center;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
    font-size: 14px;
    color: #fff;
  }
  .mask-tips {
    z-index: 8;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .download-tips {
    z-index: 9;
    position: fixed;
    left: 50%;
    top: 50%;
    width: 400px;
    height: 167px;
    margin: -84px 0 0 -200px;
    background: #000;
    border-radius: 10px;
    dl {
      margin-top: 28px;
      text-align: center;
      font-size: 14px;
      color: #fff;
    }
    dt {
      margin-bottom: 14px;
      font-size: 16px;
    }
    .c {
      padding-top: 30px;
      text-align: center;
      .btn {
        margin: 0 10px;
      }
    }
    .btn-cancel {
      display: inline-block;
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      background: #fff;
      border-radius: 8px;
      color: #333;
      cursor: pointer;
    }
    .btn-confirm {
      display: inline-block;
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
      background: #f4c000;
      border-radius: 8px;
      color: #333;
      cursor: pointer;
    }
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    background: url('~@/assets/images/close3.png') -20px 0 no-repeat;
    cursor: pointer;
  }
}
.download-box {
    width: 80%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    height: 0.48rem;
    border-radius: 10px;
    border:1px solid #F49800;
    color:#F49800 ;
    display: flex;
    align-items: center;
    justify-content: center;
}
.__vuescroll  {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
